var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSendButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON SEND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4212 10.6437L38.6175 20.1621L16.626 31.0935L18.4116 20.576L16.4212 10.6437Z",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.6157 20.1613L18.4097 20.5752",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3613 16.2705L14.0972 19.5241C13.3386 20.2794 13.3359 21.5061 14.0882 22.2667L17.4358 25.651",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4457 14.6499L6.53145 13.3672",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.45249 20.1095L1.30505 19.842",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.9953 26.1765L7.65044 27.4475",
    stroke: "#FDF3DC",
    strokeWidth: 1.65819
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendButton);
export default __webpack_public_path__ + "static/media/icon-send-button.2623e9b6ea976fc3d4b6887b7b3bb1f5.svg";
export { ForwardRef as ReactComponent };